import * as tslib_1 from "tslib";
import { EventEmitter } from '@angular/core';
import Swal from 'sweetalert2';
import * as i0 from "@angular/core";
export class SweetAlertService {
    constructor() {
        this.confirmation = new EventEmitter();
        this.cancel = new EventEmitter();
    }
    swalInfo(message) {
        Swal.fire(message);
    }
    swalError1(texto) {
        Swal.fire({
            type: 'error',
            title: 'Ups...',
            text: texto,
            confirmButtonColor: '#36ABAC'
        });
    }
    swalError() {
        Swal.fire({
            type: 'error',
            title: 'Ups...',
            text: '¡Algo salió mal!',
            confirmButtonColor: '#36ABAC'
        });
    }
    swalConfirmDialog(data) {
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#36ABAC',
            cancelButtonColor: '#E06162',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Si, eliminar'
        }).then((result) => {
            if (result.value) {
                this.confirmation.emit(data);
            }
        });
    }
    swalNewTransaction(data) {
        Swal.fire({
            imageUrl: 'assets/img/alert.png',
            title: '<h1 class="text-blue mb-5 mt-5 display-3 bold">¿Deseas realizar una<br> nueva transacción?</h1>',
            showCancelButton: true,
            focusConfirm: false,
            customClass: {
                confirmButton: 'btn-nueva btn-blue shadow-sm',
                cancelButton: 'btn-nueva btn-white mt-5 shadow-sm',
                image: 'alert-img mb-5',
                actions: 'col-11 offset-2',
                container: 'new'
            },
            confirmButtonText: '<h1>SI</h1>',
            cancelButtonText: '<h1>NO</h1>',
            position: 'bottom-start',
            padding: '8em',
            width: '100%',
            allowOutsideClick: false
        }).then((result) => {
            if (result.value) {
                this.confirmation.emit(data);
            }
            else {
                this.cancel.emit(data);
            }
        });
    }
    swalPrint() {
        Swal.fire({
            imageUrl: 'assets/img/print.gif',
            imageAlt: 'Imprimiendo',
            imageHeight: 230,
            imageWidth: 215,
            // title: 'Imprimiendo',
            // width: '100%',
            position: 'center',
            showConfirmButton: false,
            allowOutsideClick: false,
        });
    }
    swalLoading() {
        const html = '<div><img src="assets/img/loading.gif"></div>';
        Swal.fire({
            html,
            position: 'center',
            showConfirmButton: false,
            background: 'bottom',
            backdrop: 'rgba(255,255,255,0.4)',
            allowOutsideClick: false,
            customClass: {
                title: 'spinner-border'
            }
        });
    }
    swalErrorPromise(message) {
        return Swal.fire({
            type: 'error',
            title: '¡Algo salió mal!',
            text: message,
            confirmButtonColor: '#36ABAC'
        });
    }
    swalToolsAlert(text, titulo, tipo) {
        Swal.fire({
            type: tipo,
            title: titulo,
            text,
            confirmButtonColor: '#0079c8',
            allowOutsideClick: false,
            customClass: {
                popup: 'swal2-modal-content swal2-modal-alert',
                confirmButton: 'swal2-btn-gral',
                content: 'swal2-text-grey bold'
            }
        });
    }
    swalToolConfirmation(titulo, tipo, accion) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let response = false;
            yield Swal.fire({
                title: titulo,
                text: `¿Está seguro de ${accion} el equipo?`,
                type: tipo,
                showCancelButton: true,
                confirmButtonColor: '#0079c8',
                cancelButtonColor: '#dE06162',
                confirmButtonText: `Sí, ${accion}`,
                cancelButtonText: 'No',
                allowOutsideClick: false,
                customClass: {
                    popup: 'swal2-modal-content swal2-modal-alert',
                    confirmButton: 'swal2-btn-gral',
                    cancelButton: 'swal2-btn-gral',
                    content: 'swal2-text-grey bold'
                },
            }).then((result) => {
                if (result.value) {
                    response = true;
                }
            });
            return response;
        });
    }
    swalClose() {
        Swal.close();
    }
}
SweetAlertService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SweetAlertService_Factory() { return new SweetAlertService(); }, token: SweetAlertService, providedIn: "root" });
